import {
  LitElement,
  css,
  html,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js";

class SkioAddToSubscription extends LitElement {
  static styles = css`
    :host {
      /* Matched to the product page: black on warm off-white, square corners */
      --color-primary: #000;
      --color-accent: #fff;
      --color-bg: #fff;
      --color-card-bg: #fff;
      --color-border: #fff;
      --color-text: #000;
      --color-muted: #000;
      --color-strikethrough: #000;
      --radius: 0;

      position: relative;
      display: block;
      font-family: inherit;
      font-size: 16px;
      color: var(--color-text);
      margin: 20px 0 0 0;
    }

    /* ---------- Callout on the product page ---------- */

    .callout {
      background: var(--color-card-bg);
      border: 1px solid var(--color-border);
      border-radius: var(--radius);
      padding: 20px 16px;
    }

    .callout h3 {
      margin: 0 0 15px;
letter-spacing: .28px;
  text-transform: uppercase;

  font-family: gtPressura,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;
  font-size: .875rem;
  font-style: normal;
  font-weight: 500;
      color: var(--color-text);

    }

    .callout small {
      display: block;
      margin-bottom: 12px;
      font-size: 0.85em;
      color: var(--color-muted);
    }

    .callout p {
      margin: 0 0 16px;
      font-size: 0.85em;
      color: var(--color-muted);
    }

    .callout p b {
      color: var(--color-text);
      font-weight: 500;
    }

    .add-to-subscription-button {
      background: var(--color-primary);
      color: var(--color-accent);
      border: 1px solid var(--color-primary);
      border-radius: var(--radius);
      padding: 15px 0;
      width: 100%;
font-family: gtPressura,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;
      font-size: 0.85em;
      font-weight: 500;
      letter-spacing: .28px;
      text-transform: uppercase;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
    }

    .add-to-subscription-button:hover {
      background: var(--color-accent);
      color: var(--color-primary);
    }

    .add-to-subscription-button:focus-visible,
    .modal-footer button:focus-visible,
    .close-button:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    /* ---------- Modal ---------- */

    dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      z-index: 2147483647;
      background: var(--color-bg);
      border: 1px solid var(--color-primary);
      border-radius: var(--radius);
      width: calc(100% - 32px);
      max-width: 500px;
      padding: 0;
      box-shadow: none;
      color: var(--color-text);
      font-family: inherit;
    }

    dialog::backdrop {
      background: rgba(0, 0, 0, 0.4);
    }

    .modal-content {
      position: relative;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding: 20px 24px;
      border-bottom: 1px solid var(--color-border);
    }

    .modal-title {
      margin: 0;
      font-size: 1.25em;
      font-weight: 400;
      line-height: 1.3;
      color: var(--color-text);
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 12px;
        font-family: gtPressura,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;

    }

    .modal-title .date-badge {
      display: inline-block;
      border: 1px solid var(--color-primary);
      border-radius: var(--radius);
      padding: 4px 10px;
      font-size: 0.6em;
      font-weight: 500;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: var(--color-primary);
      background: transparent;
    }

    .close-button {
      background: none;
      border: none;
      font-size: 1.75em;
      font-weight: 300;
      color: var(--color-text);
      cursor: pointer;
      padding: 0;
      margin: 0;
      width: 1.5em;
      height: 1.5em;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .close-button:hover {
      opacity: 0.6;
    }

    form {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    /* Options styled like the page's purchase-option boxes */
    .option-label {
      display: flex;
      align-items: center;
      gap: 10px;
      background: transparent;
      border: 1px solid var(--color-border);
      border-radius: var(--radius);
      padding: 16px 14px;
      cursor: pointer;
      transition: border-color 0.2s;
      position: relative;
    }

    .option-label:hover {
      border-color: var(--color-primary);
    }

    .option-label.selected {
      border: 1px solid var(--color-primary);
      background: transparent;
    }

    /* Square checkbox-style radio, matching the page */
    .option-label input[type="radio"] {
      appearance: none;
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      margin: 0;
      flex-shrink: 0;
      border: 1px solid var(--color-muted);
      border-radius: 0;
      background: transparent;
      cursor: pointer;
    }

    .option-label input[type="radio"]:checked {
      background: var(--color-primary);
      border-color: var(--color-primary);
    }

    .option-label input[type="radio"]:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    .option-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }

    .option-title {
      font-size: 0.95em;
      font-weight: 500;
      color: var(--color-muted);
    }

    .option-label.selected .option-title {
      color: var(--color-text);
    }

    .delivery-policy {
      font-size: 0.85em;
      font-weight: 400;
      color: var(--color-text);
      text-transform: none;
    }

    .discount-badge {
      background: transparent;
      color: var(--color-text);
      border: 1px solid var(--color-primary);
      border-radius: var(--radius);
      padding: 3px 8px;
      font-size: 0.7em;
      font-weight: 500;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      white-space: nowrap;
    }

    .price-container {
      margin-left: auto;
      display: flex;
      align-items: baseline;
      gap: 6px;
      text-align: right;
    }

    .original-price {
      text-decoration: line-through;
      color: var(--color-strikethrough);
      font-size: 0.95em;
      font-weight: 400;
    }

    .discounted-price {
      color: var(--color-text);
      font-size: 0.95em;
      font-weight: 400;
    }

    .option-label:not(.selected) .discounted-price,
    .option-label:not(.selected) .original-price {
      color: var(--color-muted);
    }

    .modal-policy {
      padding: 0 24px 20px;
      font-size: 0.8em;
      line-height: 1.5;
      color: var(--color-muted);
    }

    .modal-policy a {
      color: var(--color-text);
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    .modal-footer {
      display: flex;
      gap: 12px;
      padding: 20px 24px 24px;
      border-top: 1px solid var(--color-border);
    }

    .modal-footer button {
      flex: 1;
      padding: 15px 24px;
      border-radius: var(--radius);
  font-family: gtPressura,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;

      font-size: 0.85em;
      font-weight: 500;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
    }

    .primary-button {
      background: var(--color-primary);
      color: var(--color-accent);
      border: 1px solid var(--color-primary);
      display: inline-flex;
      align-items: center;
      justify-content: center;

    }

    .primary-button:hover:not(:disabled) {
      background: var(--color-accent);
      color: var(--color-primary);
    }

    .secondary-button {
      background: transparent;
      color: var(--color-text);
      border: 1px solid var(--color-primary);
    }

    .secondary-button:hover:not(:disabled) {
      background: var(--color-primary);
      color: var(--color-accent);
    }

    .primary-button:disabled,
    .secondary-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    /* ---------- Success state ---------- */

    .success-screen {
      background: transparent;
      border: 1px solid var(--color-primary);
      border-radius: var(--radius);
      padding: 20px 16px;
      text-align: left;
    }

    .success-title {
      margin: 0 0 8px;
      font-size: 0.95em;
      font-weight: 500;
      color: var(--color-text);
    }

    .success-message {
      margin: 0;
      font-size: 0.85em;
      line-height: 1.5;
      color: var(--color-muted);
    }

    .success-date {
      font-weight: 500;
      color: var(--color-text);
    }

    .success-link {
      display: inline-block;
      margin-top: 12px;
      font-size: 0.85em;
      font-weight: 400;
      color: var(--color-text);
      text-decoration: underline;
      text-underline-offset: 3px;
      transition: opacity 0.2s;
    }

    .success-link:hover {
      opacity: 0.6;
    }

    /* ---------- Loading / errors ---------- */

    .loading-spinner {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 1.5px solid currentColor;
      border-top-color: transparent;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    @media (prefers-reduced-motion: reduce) {
      .loading-spinner { animation-duration: 2s; }
    }

    .error-message {
      background: transparent;
      border: 1px solid #b3261e;
      border-radius: var(--radius);
      padding: 12px;
      color: #b3261e;
      font-size: 0.85em;
      text-align: left;
    }

    /* ---------- Mobile ---------- */

    @media (max-width: 500px) {
      .modal-header { padding: 16px; }
      form { padding: 16px; }
      .modal-policy { padding: 0 16px 16px; }
      .modal-footer {
        flex-direction: column;
        gap: 8px;
        padding: 16px;
      }
      .option-label { flex-wrap: wrap; }
      .price-container { margin-left: auto; }
    }
  `;

  static properties = {
    isLoading: { type: Boolean },
    isAuthenticated: { type: Boolean },
    productId: { type: String },
    product: { type: Object },
    selectedVariant: { type: Object },
    upcomingSubscription: { type: Object },
    eligibleForSubscription: { type: Boolean },
    eligibleForOneTimeUpsell: { type: Boolean },
    oneTimeOnly: { type: Boolean },
    hasSubscriptionPlans: { type: Boolean },
    oneTimeUpsellPercentageOff: { type: Number },
    selectedOption: { type: String },
    selectedSellingPlan: { type: Object },
    showSuccessScreen: { type: Boolean },
    previouslyAddedProducts: { type: String },
    isAddingToSubscription: { type: Boolean },
    addToSubscriptionError: { type: String },
  };

  constructor() {
    super();
    this.initializeDefaultState();
  }

  async connectedCallback() {
    super.connectedCallback();
    await this.initialize();
    this.isLoading = false;
    this.bindFormEvents();
  }

  initializeDefaultState() {
    this.isLoading = false;
    this.eligibleForSubscription = false;
    this.eligibleForOneTimeUpsell = false;
    this.oneTimeOnly = false;
    this.hasSubscriptionPlans = false;
    this.selectedOption = "subscription";
    this.showSuccessScreen = false;
    this.isAddingToSubscription = false;
    this.addToSubscriptionError = null;
  }

  async initialize() {
    this.checkAuthentication();
    if (!this.isAuthenticated) return;

    const subscription = await this.fetchUpcomingSubscription();
    this.upcomingSubscription = subscription;

    const product = await this.fetchProduct();
    this.product = product;
  }

  checkAuthentication() {
    this.isAuthenticated = !!window.Skio?.storefrontUser?.idToken;
  }

  async fetchUpcomingSubscription() {



    const query = `
      query storefrontGetUpcomingSubscription($storefrontUserId: uuid) {
        Subscriptions(where: {
          status: {
            _eq: "ACTIVE"
          }
          storefrontUserId: {
            _eq: $storefrontUserId
          }
        }, order_by: {
          nextBillingDate: asc
        }, limit: 1) {
          id
          status
          nextBillingDate
          SubscriptionLines(
            where: { removedAt: { _is_null: true } }
            limit: 1
            order_by: { createdAt: asc }
          ) {
            OriginalSellingPlan {
              PricingPolicies {
                percentageOff
                fixedPrice
              }
            }
          }
          DeliveryPolicy { 
            interval 
            intervalCount 
          }
          BillingPolicy {
            interval
            intervalCount
          }
        }
      }
    `;

    const variables = {
      storefrontUserId: window.Skio?.storefrontUser?.id,
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      const subscription = response.data.Subscriptions[0];



      // Filter out prepaid subscriptions
      if (this.isPrepaidSubscription(subscription)) {
        return null;
      }

      return subscription;
    } catch (error) {
      console.error("Error fetching upcoming subscription:", error);
      return null;
    }
  }

  async fetchProduct() {
    const query = `
      query Products($where: Product_bool_exp) {
        Products(where: $where) {
          title
          canUpsell
          oneTimeUpsellPercentageOff
          ProductVariants {
            enableOneTimeUpsell
            platformId
            price
            compareAtPrice
            SellingPlanGroupResources(where: {SellingPlanGroup: { name: { _eq: "Subscription" } }}) {
              SellingPlanGroup {
                customName
                SellingPlans {
                  id
                  platformId
                  PricingPolicies {
                    percentageOff
                    fixedPrice
                  }
                  DeliveryPolicy {
                    interval
                    intervalCount
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      where: {
        platformId: {
          _eq: `gid://shopify/Product/${this.productId}`,
        },
      },
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      console.log("Product data:", response.data.Products[0]);
      return response.data.Products[0];
    } catch (error) {
      console.error("Error fetching product:", error);
      return null;
    }
  }

  isPrepaidSubscription(subscription) {
    const { DeliveryPolicy, BillingPolicy } = subscription;
    return (
      DeliveryPolicy.interval !== BillingPolicy.interval ||
      DeliveryPolicy.intervalCount !== BillingPolicy.intervalCount
    );
  }

  formatDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.toLocaleString("en-US", {
      month: "short",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  }

  formatMoney(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  }

  bindFormEvents() {
    const variantInput = document.querySelector("#product-details-form [name=id]");
    if (!variantInput) return;

    console.log('selected variant', variantInput.value);

    this.updateSelectedVariant(variantInput.value);
    this.checkVariantEligibility(this.selectedVariant);
    this.checkPreviouslyAddedProducts();

    variantInput.addEventListener("change", (e) => {
      this.updateSelectedVariant(e.target.value);
      this.checkVariantEligibility(this.selectedVariant);
      this.checkPreviouslyAddedProducts();
    });
  }

  checkPreviouslyAddedProducts() {
    let previouslyAddedProducts =
      window.sessionStorage.getItem("skio_upsell_added_products") || "";
    if (previouslyAddedProducts.includes(this.selectedVariant.platformId)) {
      this.showSuccessScreen = true;
    } else {
      this.showSuccessScreen = false;
    }
  }

  updateSelectedVariant(variantId) {
    this.selectedVariant = this.product.ProductVariants.find((variant) =>
      variant.platformId.includes(variantId)
    );
  }

  checkVariantEligibility(variant) {
    if (!variant) return;

    this.hasSubscriptionPlans = variant.SellingPlanGroupResources.length > 0;

    // Subscribe is only offered when the variant has a selling plan with the
    // same delivery interval as the upcoming subscription
    this.eligibleForSubscription =
      !!this.upcomingSubscription &&
      !!this.findMatchingSellingPlan(this.findMatchingSellingPlanGroup());

    // Non-standard frequency: the item can only be added as a one-time purchase
    this.oneTimeOnly = this.hasSubscriptionPlans && !this.eligibleForSubscription;

    this.eligibleForOneTimeUpsell =
      this.oneTimeOnly || (variant.enableOneTimeUpsell && this.product.canUpsell);

    this.selectedOption = this.eligibleForSubscription ? "subscription" : "one-time";
  }

  formatFrequency() {
    const { interval, intervalCount } = this.upcomingSubscription.DeliveryPolicy;
    const unit = interval.toLowerCase();
    return intervalCount === 1 ? unit : `${intervalCount} ${unit}s`;
  }

  getSubscriptionPrice() {
    const sellingPlanGroup = this.findMatchingSellingPlanGroup();
    const sellingPlan = this.findMatchingSellingPlan(sellingPlanGroup);

    if (!sellingPlan)
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };

    this.selectedSellingPlan = sellingPlan;

    const pricingPolicy = sellingPlan.PricingPolicies[0];
    let discount, price;

    if (pricingPolicy.percentageOff) {
      discount = `${pricingPolicy.percentageOff}%`;
      price =
        this.selectedVariant.price * (1 - pricingPolicy.percentageOff / 100);
    } else if (pricingPolicy.fixedPrice) {
      discount = this.formatMoney(pricingPolicy.fixedPrice);
      price = this.selectedVariant.price - pricingPolicy.fixedPrice;
    }

    return {
      discount,
      price: this.formatMoney(price),
    };
  }

  getOneTimePrice() {
    if (!this.product.oneTimeUpsellPercentageOff) {
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };
    }

    const discount = `${this.product.oneTimeUpsellPercentageOff * 100}%`;
    const price =
      this.selectedVariant.price *
      (1 - this.product.oneTimeUpsellPercentageOff);

    return {
      discount,
      price: this.formatMoney(price),
    };
  }

  findMatchingSellingPlanGroup() {
    console.log(this.selectedVariant)
    return this.selectedVariant.SellingPlanGroupResources.find((group) =>
      group.SellingPlanGroup.SellingPlans.some((plan) =>
        this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
      )
    );
  }

  findMatchingSellingPlan(sellingPlanGroup) {
    if (!sellingPlanGroup) return null;

    return sellingPlanGroup.SellingPlanGroup.SellingPlans.find((plan) =>
      this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
    );
  }

  isMatchingDeliveryPolicy(deliveryPolicy) {
    return (
      deliveryPolicy.interval ===
        this.upcomingSubscription.DeliveryPolicy.interval &&
      deliveryPolicy.intervalCount ===
        this.upcomingSubscription.DeliveryPolicy.intervalCount
    );
  }

  async addToSubscription() {
    // Clear any previous errors and set loading state
    this.addToSubscriptionError = null;
    this.isAddingToSubscription = true;

    const productVariantPlatformId = this.selectedVariant.platformId;
    const isOneTimeUpsell = this.selectedOption === "one-time";
    const subscriptionId = this.upcomingSubscription.id;

    const mutation = `
      mutation storefrontEditSubscriptionLines($input: EditSubscriptionLinesInput!) {
        editSubscriptionLines(input: $input) {
          subscriptionId
        }
      }
    `;

    const variables = {
      input: {
        subscriptionId,
        subscriptionLinesToCreate: [
          {
            customAttributes: [
              {
                key: "add-to-subscription-component",
                value: "true"
              }
            ],
            productVariantPlatformId,
            quantity: 1,
            isOneTimeUpsell,
          },
        ],
      },
    };

    console.log("Adding to subscription:", { mutation, variables });

    try {
      const response = await window.Skio.graphQLRequest({
        query: mutation,
        variables,
      });

      // Close modal and show success screen
      this.closeModal();
      let previouslyAddedProducts =
        window.sessionStorage.getItem("skio_upsell_added_products") || "";
      window.sessionStorage.setItem(
        "skio_upsell_added_products",
        `${previouslyAddedProducts}, ${this.selectedVariant.platformId}`
      );

      this.showSuccessScreen = true;

      return response;
    } catch (error) {
      console.error("Error adding to subscription:", error);
      this.addToSubscriptionError = "Error adding to subscription. Please try again.";
      return error;
    } finally {
      this.isAddingToSubscription = false;
    }
  }

  openModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.showModal();
      this.setupModalEventListeners(dialog);
    }
  }

  closeModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.close();
      this.removeModalEventListeners(dialog);
    }
  }

  setupModalEventListeners(dialog) {
    dialog.addEventListener("click", this.handleBackdropClick.bind(this));
  }

  removeModalEventListeners(dialog) {
    dialog.removeEventListener("click", this.handleBackdropClick.bind(this));
  }

  handleBackdropClick(e) {
    if (e.target.tagName === "DIALOG") {
      this.closeModal();
    }
  }

  renderModal() {
    const oneTimePrice = this.getOneTimePrice();
    const subscriptionPrice = this.getSubscriptionPrice();

    return html`
      <dialog>
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">
              ${this.oneTimeOnly ? "Add One-Time to Next Order" : "Add to Subscription"}
              <span class="date-badge"
                >${this.formatDate(
                  this.upcomingSubscription.nextBillingDate
                )}</span
              >
            </h2>
            <button class="close-button" @click=${this.closeModal}>
              &times;
            </button>
          </div>
          <form>
            ${this.addToSubscriptionError
              ? html`<div class="error-message">${this.addToSubscriptionError}</div>`
              : null}

            ${this.eligibleForOneTimeUpsell
              ? this.renderOneTimeOption(oneTimePrice)
              : null}
            ${this.eligibleForSubscription
              ? this.renderSubscriptionOption(subscriptionPrice)
              : null}
          </form>
            
          <div class="modal-policy">
            ${this.selectedOption === 'subscription' ? 
              html`<small>By clicking Add to Order, you’re adding this item to your subscription. You’ll be charged automatically at the listed price and frequency until canceled. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`
            : html`<small>By selecting Add to Order, you agree to a one-time charge for this item, which will be added to your next subscription shipment. This item will not renew or be billed again. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`}
          </div>
          
          <div class="modal-footer">
            <button 
              class="primary-button" 
              @click=${this.addToSubscription}
              ?disabled=${this.isAddingToSubscription}
            >
              ${this.isAddingToSubscription
                ? html`<span class="loading-spinner"></span>`
                : "ADD TO ORDER"}
            </button>
            <button
              class="secondary-button"
              @click=${this.closeModal}
              type="button"
              ?disabled=${this.isAddingToSubscription}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    `;
  }

  renderOneTimeOption(oneTimePrice) {
    const isSelected = this.selectedOption === "one-time";

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "one-time")}
      >
        <input
          type="radio"
          name="addType"
          value="one-time"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "one-time")}
        />
        <div class="option-content">
          <span class="option-title">One-time purchase</span>
          <div class="delivery-policy">Ships once with your next order</div>
        </div>
        ${oneTimePrice.discount
            ? html`<span class="discount-badge text-2xl"
                >Save ${oneTimePrice.discount}</span
              >`
            : null}
        <div class="price-container">
          
          <span class="discounted-price">${oneTimePrice.price}</span>
        </div>
      </label>
    `;
  }

    renderSubscriptionOption(subscriptionPrice) {
    const isSelected = this.selectedOption === "subscription";
    const oneTimePrice = this.getOneTimePrice();

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "subscription")}
      >
        <input
          type="radio"
          name="addType"
          value="subscription"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "subscription")}
        />
        <div class="option-content">
          <span class="option-title">Subscribe</span>
          <div class="delivery-policy">
            Every ${this.upcomingSubscription.DeliveryPolicy.intervalCount}
            ${this.upcomingSubscription.DeliveryPolicy.interval.toLowerCase()}
          </div>
        </div>
        ${subscriptionPrice.discount
            ? html`<span class="discount-badge"
                >Save ${subscriptionPrice.discount}</span
              >`
            : null}
        <div class="price-container">
          ${oneTimePrice.price === subscriptionPrice.price
            ? null
            : html`<span class="original-price">${oneTimePrice.price}</span>`}
          <span class="discounted-price">${subscriptionPrice.price}</span>
        </div>
      </label>
    `;
  }

  getOriginalPrice() {
    return this.selectedVariant.compareAtPrice
      ? this.formatMoney(this.selectedVariant.compareAtPrice)
      : this.formatMoney(this.selectedVariant.price);
  }

  renderSuccessScreen() {
    return html`
      <div class="success-screen">
        <h2 class="success-title">Added to Your Next Order</h2>
        <p class="success-message">
          This item will be included in your next subscription order shipment on
          <span class="success-date"
            >${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span
          >
        </p>
        <a href="/a/account/subscriptions" class="success-link">
          View and manage my subscriptions ->
        </a>
      </div>
    `;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    // Show success screen if item was added successfully
    if (this.showSuccessScreen) {
      return this.renderSuccessScreen();
    }

    return html`
      <div class="callout">
        <h3>${this.oneTimeOnly ? "Add to Your Next Order" : "Add to Upcoming Subscription"}</h3>
        ${this.oneTimeOnly
          ? html`<p>Add this item as a one-time purchase to your order shipping on <b>${this.formatDate(this.upcomingSubscription.nextBillingDate)}</b>. It won't repeat on future orders.</p>`
          : html`<p>You can directly add this item to your upcoming subscription order shipping on <b>${this.formatDate(this.upcomingSubscription.nextBillingDate)}</b>
        </p>`}
        <button
          class="add-to-subscription-button"
          @click=${() => this.openModal()}
        >
          ${this.oneTimeOnly ? "Add one-time to next order" : "Add to next order and save"}
        </button>
      </div>

      ${this.renderModal()}
    `;
  }

  shouldRender() {
    return (
      this.isAuthenticated &&
      this.upcomingSubscription &&
      this.hasSubscriptionPlans &&
      this.selectedVariant
    );
  }
}

customElements.define("skio-add-to-subscription", SkioAddToSubscription);
